import React from 'react';
import BaseTasksPage from '../BaseTasksPage';
import { ProjectPlanTask } from '../projectPlanTaskService';
import useAdditionalWorkflowLaunchNavigator from './additionalWorkflowLaunchNavigator';
import AdditionalWorkflowSteps, { AdditionalWorkflowStepId } from './AdditionalWorkflowSteps';
import { useConflictsContext } from './AdditionalWorkflowLaunchWrapper';
import { useProjectContext } from '../../view/ProjectContext';

export default function AdditionalWorkflowKeyDatesPage() {
  const navigator = useAdditionalWorkflowLaunchNavigator();
  const conflictsContext = useConflictsContext();
  const projectContext = useProjectContext();

  const hasGroups = !!projectContext.plan?.hasGroups;

  const getPrevClickHandler = () => {
    if (hasGroups) {
      return navigator.openGroupsPage;
    } else if (navigator.isAiFlow) {
      return navigator.openVerifyDataPage;
    } else {
      return undefined;
    }
  };

  return (
    <BaseTasksPage
      filterFunc={(task: ProjectPlanTask) => task.isKeyDate}
      roadmap={(
        <AdditionalWorkflowSteps
          currentStep={AdditionalWorkflowStepId.KEY_DATES}
          hasConflicts={conflictsContext.hasConflicts}
          hasGroups={projectContext.plan?.hasGroups}
        />
      )}
      onPrevClicked={getPrevClickHandler()}
      onNextClicked={navigator.openAllTasksPage}
      forceShowKeyDatesOnly
    />
  );
}
